module.exports = __webpack_public_path__ + "img/ms.da7a1b3b.png";